<template>
  <LayoutGame>
    <div class="pumpkin-clock">
      <Home />
      <Game />
      <GameOver />
      <Settings />
    </div>
  </LayoutGame>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'PumpkinClock',
  components: {
    Home: () => import('@/components/practices/pumpkin_clock/Home.vue'),
    Game: () => import('@/components/practices/pumpkin_clock/Game.vue'),
    GameOver: () => import('@/components/practices/pumpkin_clock/GameOver.vue'),
    LayoutGame: () => import('@/layouts/LayoutGame.vue'),
    Settings: () => import('@/components/practices/Settings.vue'),
  },
  computed: {
    ...mapGetters({
      currentExercise: 'pumpkinClock/currentExercise',
      currentLives: 'pumpkinClock/currentLives',
      exerciseCompleted: 'pumpkinClock/exerciseCompleted',
      homeScreenStatus: 'pumpkinClock/homeScreenStatus',
      muteStatus: 'settings/muteStatus',
    }),
  },
  watch: {
    muteStatus: state => {
      if (state) {
        sounds.mute(true);
      } else {
        sounds.mute(false);
      }
    },
  },
  mounted() {
    sounds.pumpkinClockBackground.play();
  },
};
</script>

<style lang="scss">
@import '@/styles/main.scss';

.pumpkin-clock {
  // Debugging CSS
  height: 100vh;
  background-color: green;
  // End of Debugging CSS
  font-size: 5vh;

  button {
    background-color: #fff;
    color: #ff8d00;
    padding: 10px 20px;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    text-align: center;
    font-family: 'VanillaExtractRegular';
    margin: 1em;
  }

  .mute-button {
    position: absolute;
    right: 2.5vw;
    top: 2.5vh;

    .mute-button__image {
      height: 12.5vh;
      cursor: pointer;
    }
  }
}
</style>
